export default "__VITE_ASSET__68465477__"